import { defineCollection } from "@rebasepro/cms-types";
import { policy } from "@rebasepro/types";
import customersCollection from "./customers.js";

const syncLogsCollection = defineCollection({
    name: "Sync Logs",
    singularName: "Sync Log",
    slug: "sync_logs",
    table: "sync_logs",
    description: "Audit trail of all webhook events received from Shopify/Odoo and outbound API calls. Stores raw payloads for debugging.",
    securityRules: [
        { operation: "select", roles: ["admin"] },
        { operations: ["insert", "update", "delete"], roles: ["admin"] },
        // Ver la nota en transactions.ts. Aqui importa especialmente: los
        // webhooks escriben el log dentro de un try/catch "no bloqueante", asi
        // que sin esta regla los fallos se descartan en silencio.
        { operations: ["insert", "update", "delete"], condition: policy.serverContext() }
    ],
    properties: {
        id: {
            name: "ID",
            type: "string",
            isId: "uuid",
            admin: { readOnly: true }
        },
        source: {
            name: "Source",
            type: "string",
            validation: { required: true },
            enum: [
                { id: "shopify", label: "Shopify", color: "blue" },
                { id: "odoo", label: "Odoo", color: "purple" },
                { id: "manual", label: "Manual", color: "gray" }
            ]
        },
        event_type: {
            name: "Event Type",
            type: "string",
            validation: { required: true },
            description: "E.g. 'orders/paid', 'refund/created', 'customer/updated'"
        },
        direction: {
            name: "Direction",
            type: "string",
            validation: { required: true },
            enum: [
                { id: "inbound", label: "Inbound (Webhook)", color: "green" },
                { id: "outbound", label: "Outbound (API Call)", color: "orange" }
            ]
        },
        status: {
            name: "Status",
            type: "string",
            defaultValue: "pending",
            enum: [
                { id: "success", label: "Success", color: "green" },
                { id: "failed", label: "Failed", color: "red" },
                { id: "pending", label: "Pending", color: "yellow" }
            ]
        },
        payload: {
            name: "Payload",
            type: "map",
            keyValue: true,
            description: "Raw request/response body",
            admin: { hideFromCollection: true }
        },
        error_message: {
            name: "Error Message",
            type: "string",
            admin: { multiline: true },
            description: "Error details if the sync failed"
        },
        related_customer: {
            name: "Related Customer",
            type: "relation",
            relation: {
                kind: "belongsTo",
                target: () => customersCollection,
            }
        },
        created_at: {
            name: "Created At",
            type: "date",
            mode: "date_time",
            autoValue: "on_create",
            admin: { readOnly: true }
        }
    },
    admin: {
        icon: "RefreshCw",
        group: "Loyalty",
        defaultViewMode: "list",
        enabledViews: ["list", "table"],
        // A log is read when something went wrong, so the error travels with the
        // row instead of hiding one click away.
        listProperties: ["source", "direction", "error_message", "related_customer"],
        previewProperties: ["event_type", "status"],
        openEntityMode: "side_panel",
        exportable: true,
        sort: ["created_at", "desc"],
        propertiesOrder: [
            "source", "event_type", "direction", "status",
            "error_message", "related_customer",
            "payload", "created_at"
        ]
    }
});

export default syncLogsCollection;
